import { render, staticRenderFns } from "./NsFooter.vue?vue&type=template&id=3f5c041a&scoped=true"
import script from "./NsFooter.vue?vue&type=script&lang=js"
export * from "./NsFooter.vue?vue&type=script&lang=js"
import style0 from "./NsFooter.vue?vue&type=style&index=0&id=3f5c041a&prod&scoped=true&lang=css"
import style1 from "./NsFooter.vue?vue&type=style&index=1&id=3f5c041a&prod&scoped=true&lang=scss"
import style2 from "./NsFooter.vue?vue&type=style&index=2&id=3f5c041a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c041a",
  null
  
)

export default component.exports